import api from '../api.js';
import {iniciarRequisicao} from "../../helpers/index.js"

export async function incluirPedido(parametros) {
  const headers = iniciarRequisicao();

  return await api({
    method: "post",
    url: `pedidos-compra/${parametros.idpedido}/exportacao/sankhya`,
    headers,
    data: parametros
  });
}

export async function alterarPedido(id_pedido) {
  const headers = iniciarRequisicao();

  return await api({
    method: "put",
    url: `pedidos-compra/${id_pedido}/exportacao/sankhya`,
    headers
  });
}
